import React, { useEffect, useState } from "react";
import s from "./Users.module.scss";
import Card from "../../../../global components/Card/Card";
import Table from "./Local component/Table";
import useSWR from "swr";
import { UseAuthToken } from "../../../../libs/api/userSession";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import { Skeleton } from "antd";
import { AllUsers } from "../../../../libs/Utils/Types/User";
import Unauthorised from "../../../../global components/Unauthorised";
import { Link } from "react-router-dom";
import ArrowRight from "../../../../global components/Icons/ArrowRight";

function Users() {
  const token = UseAuthToken();

  const [filter, setFilter] = useState<
    "verified" | "pending" | "unverified" | ""
  >("");
  const {
    data: user,
    error,
    isLoading,
  } = useSWR<{ data: AllUsers }, any, any>(
    token ? ["api/admin/users/stats", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      retryOnError: false,
    },
  );
  const [unauthorised, setUnauthorised] = useState<
    boolean | { title: string; message: string }
  >(false);
  const pendingUsers = user?.data?.find((item) => item.status === "pending");
  const verifiedUsers = user?.data?.find((item) => item.status === "verified");
  const unVerifiedUsers = user?.data?.find(
    (item) => item.status === "unverified",
  );

  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setUnauthorised(true);
      } else {
        setUnauthorised({
          title: "Error",
          message: e.message || "Something went wrong",
        });
      }
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s.titles}>
          <h3 className={s.title}>Users</h3>
          <h4 className={s.subtitle}>Manage all users here</h4>
        </div>
        <Link to={"/dashboard/users/send-message"} className={s.sendBtn}>
          <p> Send message</p>
          <ArrowRight className={s.icon} />
        </Link>
      </div>
      <div className={s.cards}>
        {unauthorised ? (
          typeof unauthorised === "boolean" ? (
            <div className={s.cardError}>
              <Unauthorised />
            </div>
          ) : (
            <div className={s.cardError}>
              <Unauthorised error={unauthorised} />
            </div>
          )
        ) : (
          <>
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("verified")}
                label="Verified"
                stat={verifiedUsers?.count || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("unverified")}
                label="Unverified"
                stat={unVerifiedUsers?.count || 0}
              />
            )}
            {isLoading ? (
              <Skeleton.Node
                active={isLoading}
                rootClassName={s.cardSkeleton}
                className={s.cardSkeleton}
              />
            ) : (
              <Card
                onClick={() => setFilter("pending")}
                label="Pending"
                stat={pendingUsers?.count || 0}
              />
            )}
          </>
        )}
      </div>
      <Table filters={filter} />
    </div>
  );
}

export default Users;
